module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.maskFlag) ? _c('div', {
    staticClass: "mask"
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4041bc6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/commonComponents/maskDiv.vue
// module id = 477
// module chunks = 1